import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Usage:
 *   <Breadcrumb items={[
 *     { label: 'Dashboard', to: '/dashboard' },
 *     { label: 'Candidates', to: '/candidates' },
 *     { label: 'John Smith' },           // no `to` = current page (not a link)
 *   ]} />
 */
const Breadcrumb = ({ items = [] }) => {
  if (items.length < 2) return null; // nothing meaningful to show for a single crumb

  return (
    <nav aria-label="Breadcrumb" style={styles.nav}>
      <ol style={styles.list}>
        {items.map((item, idx) => {
          const isLast = idx === items.length - 1;
          return (
            <li key={idx} style={styles.item}>
              {!isLast && item.to ? (
                <Link to={item.to} style={styles.link}>{item.label}</Link>
              ) : (
                <span style={isLast ? styles.current : styles.link} aria-current={isLast ? 'page' : undefined}>
                  {item.label}
                </span>
              )}
              {!isLast && <span style={styles.separator} aria-hidden="true">›</span>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

const styles = {
  nav: {
    padding: '0.5rem 0 1rem',
  },
  list: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '0.25rem',
    listStyle: 'none',
    margin: 0,
    padding: 0,
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.25rem',
  },
  link: {
    color: '#667eea',
    textDecoration: 'none',
    fontSize: '0.875rem',
    fontWeight: 500,
  },
  current: {
    color: '#6c757d',
    fontSize: '0.875rem',
    fontWeight: 400,
  },
  separator: {
    color: '#adb5bd',
    fontSize: '0.875rem',
    userSelect: 'none',
  },
};

export default Breadcrumb;
